// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-style-reset[data-v-34bae710] {\n  margin-top: 1em;\n}\n.list-style-reset li[data-v-34bae710] {\n  list-style: initial;\n  list-style-type: disc;\n  margin-left: 2em;\n}", ""]);
// Exports
module.exports = exports;
